import React, { type FC, type JSX } from 'react';
import { CloseIconContainer, HeaderWrapper, ModalHeaderContainer } from './styled';
import CloseIcon from '../../CloseIcon';

type ModalHeaderProps = {
  handleClose?: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  showShadow?: boolean;
  align?: 'center' | 'left';
  subHeader?: React.ReactNode;
  // Accessible name for the icon-only close button. Defaults to a generic label;
  // pass a descriptive one (e.g. "Close Your trip") so screen readers announce context.
  closeLabel?: string;
};

const BasicModalHeaderV2: FC<ModalHeaderProps> = ({
  children,
  className = '',
  handleClose,
  style,
  showShadow,
  align = 'center',
  subHeader,
  closeLabel = 'Close',
}): JSX.Element => (
  <HeaderWrapper className={className} $showShadow={showShadow}>
    <ModalHeaderContainer style={style} $align={align}>
      {handleClose && (
        <CloseIconContainer
          type="button"
          aria-label={closeLabel}
          data-swipe-dismiss-ignore={true}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            handleClose();
          }}
        >
          <CloseIcon />
        </CloseIconContainer>
      )}
      {children}
    </ModalHeaderContainer>
    {subHeader}
  </HeaderWrapper>
);

export default BasicModalHeaderV2;
